import { Component } from '@angular/core';
import { combineLatest, distinctUntilChanged, finalize, map, Observable } from 'rxjs';
import { ProfileConst } from 'src/app/utils';
import { CurrentUserService, LegalTermsService } from 'src/app/utils/cargo-driver-check-in-service/services';
import { LegalTermsSite } from 'src/environments/environment';
import { AcceptanceLegalTermsService } from '../services/acceptance-legal-terms.service';

@Component({
    selector: 'app-legal-terms-top-notice-bar',
    standalone: false,
    templateUrl: './legal-terms-top-notice-bar.component.html',
    styleUrl: './legal-terms-top-notice-bar.component.scss'
})
export class LegalTermsTopNoticeBarComponent {

    public visible: Observable<boolean>;
    public saving: boolean;

    constructor(
        private acceptanceLegalTermsService: AcceptanceLegalTermsService,
        private legalTermsService: LegalTermsService,
        private currentUserService: CurrentUserService
    ) {
        this.visible = this.isVisible();
    }

    get termsOfUseUrl(): string {
        return LegalTermsSite.terms_of_use;
    }

    private isValidProfile(): Observable<boolean> {
        return this.currentUserService.getProfile()
            .pipe(
                map(profile => {
                    if (!profile) {
                        return false;
                    }

                    return ![
                        ProfileConst.kiosk_pf,
                        ProfileConst.kiosk_waiting_list,
                        ProfileConst.waiting_list_wh_pf,
                        ProfileConst.warehouse_driver_checkin_pf
                    ]
                        .includes(profile);
                }),
                distinctUntilChanged()
            );
    }

    private isVisible(): Observable<boolean> {
        return combineLatest([
            this.isValidProfile(),
            this.acceptanceLegalTermsService.isTopNoticeBarVisible()
        ])
            .pipe(
                map(([validProfile, visible]) =>
                    validProfile && visible
                ),
                distinctUntilChanged()
            );
    }

    dismiss(): void {
        this.acceptanceLegalTermsService.hideTopNoticeBar();
    }

    dismissPermanently(): void {
        if (this.saving) {
            return;
        }

        this.saving = true;

        this.legalTermsService.dismissLegalTerms()
            .pipe(
                finalize(() => {
                    this.dismiss();
                })
            )
            .subscribe();
    }

}
